export enum ClinicIdsEnum {
  doctors4ua = 1,
  DKKids,
  DentistOmnycare,
  YourBaby
}
